import React from 'react'
import useSWR from 'swr'
import MerchandiseBasketSummary from '../event/merchandise/basket-summary'

const fetcher = (url) => fetch(url).then((res) => res.json())

const BasketStockItems = ({ itemsFromBasket, isLoading, mutate }) => {
  if (!itemsFromBasket || itemsFromBasket.length === 0) {
    return null
  }

  // Extract unique stock item IDs
  const itemIds = [...new Set(itemsFromBasket.map((item) => item.stockItem?.id))].filter(Boolean)

  // Fetch full stock item details from our database
  const { data: items } = useSWR(
    itemIds.length > 0 ? `/basket-stock_items?ids=${itemIds.join(',')}` : null,
    fetcher
  )

  if (!items) {
    return (
      <div className="border-t border-b border-gray-200 dark:border-gray-700 py-6">
        <div className="text-gray-600 dark:text-gray-400">Loading merchandise...</div>
      </div>
    )
  }

  // Format items with basket counts
  const formattedItems = items.map((item) => {
    const inBasket = itemsFromBasket.filter((i) => i.stockItem?.id === item.spektrix_id)
    const firstItem = inBasket[0]

    return {
      ...item,
      items: inBasket,
      inBasket: inBasket.length,
      hasStock: firstItem?.stockItem?.stockLevel > 0,
      price: (firstItem?.price || 0) + (firstItem?.discount || 0)
    }
  })

  return (
    <ul role="list" className="border-t border-b border-gray-200 dark:border-gray-700 divide-y divide-gray-200 dark:divide-gray-700">
      {formattedItems.map((item) => (
        <li key={item.id} className="flex py-6">
          <div className="flex-shrink-0">
            {item.image_url && (
              <img
                src={item.image_url}
                alt={item.name}
                className="w-24 h-24 rounded-md object-cover"
              />
            )}
          </div>

          <div className="ml-4 flex-1 flex flex-col">
            <div className="flex justify-between">
              <div>
                <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                  {item.name}
                </h4>
                {item.description && (
                  <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                    {item.description}
                  </p>
                )}
              </div>
              <p className="ml-4 text-sm font-medium text-gray-900 dark:text-white">
                £{(item.price * item.inBasket).toFixed(2)}
              </p>
            </div>

            <div className="mt-4 flex items-center">
              <MerchandiseBasketSummary
                merchandiseId={item.spektrix_id}
                inBasket={item.inBasket}
                mutate={mutate}
                isLoading={isLoading}
                hasStock={item.hasStock}
                itemName={item.name}
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default BasketStockItems
